<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-curso-idioma />
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Curso Idiomas
    </h3>
    <ver-documento />
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                dark
                @click.native.stop="crearActualizarCursoIdioma({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Curso idioma</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <!-- <td class="text-xs-center">{{ items.item.nombre }}</td> -->
            <td class="text-xs-center"> {{items.item.idioma? items.item.idioma.nombre_idioma:""}}</td>
            <td class="text-xs-center">{{ items.item.parametro_lectura?items.item.parametro_lectura.valor:"" }}</td>
            <td class="text-xs-center">{{ items.item.parametro_expresion?items.item.parametro_expresion.valor:"" }}</td>
            <td class="text-xs-center">{{ items.item.parametro_escritura?items.item.parametro_escritura.valor:"" }}</td>
            <td class="text-xs-center">
              {{ items.item.certificado ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">{{ items.item.gestion }}</td>
            <td class="text-xs-center">{{ items.item.duracion_horas }}</td>
            <td class="text-xs-center">{{ items.item.url_documento ? 'Si' : 'No' }}</td>
            <td class="nowrap text-xs-center">
              <v-tooltip bottom v-if="estado==1 || rol!=42">
                <v-btn
                  icon
                  slot="activator"
                  color="primary"
                  @click.native="crearActualizarCursoIdioma(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  color="green"
                  
                  dark
                  icon
                  slot="activator"
                  @click.native="verDocumento(items.item)"
                >
                  <v-icon color="dark">visibility</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="estado==1 || rol!=42">
                <v-btn
                  icon
                  slot="activator"
                  color="error"
                  @click="deleteItem(items.item.id, 'cursoIdioma')"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarCursoIdioma from "../dialogs/CrearActualizarIdiomas"; // Componente de creación y actualización
import VerDocumento from "../dialogs/VerDocumento.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  props: ["persona"],
  // Variables iniciales del componente
  data() {
    return {
      url: "cursoIdiomas",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        // { text: "Nro.", align: "center", sortable: false, value: "",},
        { text: "Idioma", value: "id_idioma", align: "center", sortable: false },
        { text: "Lectura", value: "certificado", align: "center" },
        { text: "Expresion Oral", value: "calificacion", align: "center" },
        { text: "Escritura", value: "calificacion", align: "center" },
        { text: "Certificado", value: "calificacion", align: "center" },
        { text: "Año", value: "gestion", align: "center" },
        { text: "Duracion en horas", value: "duracion_horas", align: "center" },
        { text: "Documento adjunto", value: "url_documento", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        id_estado

        certificado
        calificacion
        url_documento	
        id_idioma
        id_institucion
        id_parametro_lectura
        id_parametro_expresion
        id_parametro_escritura
        idioma{
          id
          nombre_idioma
        }
        institucion{
          id
          nombre_institucion
        }
        parametro_lectura{
          id
          valor
        }
        parametro_expresion{
          id
          valor
        }
        parametro_escritura{
          id
          valor
        }
        gestion
        duracion_horas
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [],
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id
        }
      ],
      estado:[],
      rol:[]

    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    this.$bus.$on("verDocumento", item => {
      this.url = item;
      this.dialog = true;
    });
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.obtenerEstadoFicha();
  },
  // Métodos y funciones del componente
  methods: {
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    crearActualizarCursoIdioma(item) {
      this.$bus.$emit("openDialogCrearActualizarCursoIdioma", item);
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
       this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarCursoIdioma,
    VerDocumento
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/Idiomas.vue